import { rootApi } from '../rootApi';

/**
 * Kullaniciya ozel kalici tablo (kolon) tercihleri.
 * Base route: /v1/UserTablePreferences
 *
 * DTO: { tableKey: string, columnOrder: string[], hiddenColumns: string[] }
 * Tum cevaplar ResponseInfo<T> zarfinda doner ({ data, ... }).
 */
export const userTablePreferencesApi = rootApi.injectEndpoints({
    endpoints: (builder) => ({
        getTablePreference: builder.query({
            query: (tableKey) => ({
                url: 'v1/UserTablePreferences/GetByTableKey',
                method: 'GET',
                params: { tableKey }
            }),
            transformResponse: (res) => res?.data ?? null,
            providesTags: (res, err, tableKey) => [{ type: 'UserTablePreference', id: tableKey }]
        }),
        getMyTablePreferences: builder.query({
            query: () => ({ url: 'v1/UserTablePreferences/GetMyPreferences', method: 'GET' }),
            transformResponse: (res) => res?.data ?? [],
            providesTags: [{ type: 'UserTablePreference', id: 'LIST' }]
        }),
        upsertTablePreference: builder.mutation({
            query: (body) => ({
                url: 'v1/UserTablePreferences/Upsert',
                method: 'POST',
                body // { tableKey, columnOrder, hiddenColumns }
            }),
            invalidatesTags: (res, err, body) => [{ type: 'UserTablePreference', id: body?.tableKey }]
        }),
        resetTablePreference: builder.mutation({
            query: (tableKey) => ({ url: `v1/UserTablePreferences/${tableKey}`, method: 'DELETE' }),
            invalidatesTags: (res, err, tableKey) => [{ type: 'UserTablePreference', id: tableKey }]
        })
    }),
    overrideExisting: false
});

export const {
    useGetTablePreferenceQuery,
    useLazyGetTablePreferenceQuery,
    useGetMyTablePreferencesQuery,
    useUpsertTablePreferenceMutation,
    useResetTablePreferenceMutation
} = userTablePreferencesApi;
